import {
  ActivityPriceBreakdown,
  ActivityShopResponse,
  IExperiencesPassengerCounts,
  RewardsPrice,
} from "redmond";
import { BookingCompleteData } from "@capone/common";
import { getTotalTravelersCount } from "../../common/utils";

export const buildActivityBookingData = (params: {
  earnedRewards: RewardsPrice | undefined;
  priceBreakdown: ActivityPriceBreakdown | undefined;
  travelerCounts: IExperiencesPassengerCounts | undefined;
  activityShop: ActivityShopResponse | undefined;
  reservationId: string | false | undefined;
}): BookingCompleteData => {
  const { earnedRewards, priceBreakdown, travelerCounts, activityShop, reservationId } =
    params;

  return {
    earnedRewards: earnedRewards
      ? {
          value: earnedRewards.value,
          currency: earnedRewards.currency,
          currencyDescription: earnedRewards.currencyDescription,
        }
      : { value: 0, currency: "Miles" },
    booking: {
      type: "activity",
      itineraryId: reservationId || "",
      title: activityShop?.name ?? "",
      date: priceBreakdown?.date ?? "",
      ...(priceBreakdown?.startTime ? { time: priceBreakdown.startTime } : {}),
      ticketCount: getTotalTravelersCount(travelerCounts),
      ...(activityShop?.coverImage ? { imageUrl: activityShop.coverImage } : {}),
    },
  };
};
